import React, { type FunctionComponent } from 'react'
import { AccountManagementBreadcrumbs } from 'domains/account-management/components/breadcrumbs/AccountManagementBreadcrumbs'

export const ListAccountsBreadcrumbs: FunctionComponent = () => <AccountManagementBreadcrumbs />
